import { TextLayer } from '@deck.gl/layers';
const createLabelLayer = (nodeViewMap, showLabels) => {
    const nodeViews = Array.from(nodeViewMap.values());
    return new TextLayer({
        id: 'text-layer',
        data: nodeViews,
        pickable: false,
        getPosition: (d) => [d.position[0], d.position[1]],
        getText: (d) => d.label,
        getSize: (d) => d.labelFontSize,
        getColor: (d) => d.labelColor ? d.labelColor : [0, 0, 0],
        getAngle: 0,
        sizeScale: 1,
        sizeMinPixels: 15,
        sizeMaxPixels: 50,
        getTextAnchor: 'middle',
        getAlignmentBaseline: 'center',
        visible: showLabels
    });
};
export { createLabelLayer };
